import { Snackbar } from '@mui/material';
import { toast } from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';
import { forwardRef, Fragment } from 'react';
import MuiAlert from '@mui/material/Alert';
import Swal from 'sweetalert2';

const CustomToastComponent = ({ message }) => {
    return <div dangerouslySetInnerHTML={{ __html: message }} />;
};
export const saveNotification = (message) => {
    toast.success(<CustomToastComponent message={message} />, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
    });
};
export const errorNotification = (message) => {
    toast.error('' + message + '', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
    });
};

export const warningNotification = (message) => {
    toast.warning(<CustomToastComponent message={message} />, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
    });
};

export const warningNotification1 = (message, message2 = undefined, autoClose = undefined, autoCloseUpdate = undefined) => {


    const id = toast.warning(<CustomToastComponent message={message} />, {
        position: 'top-right',
        autoClose: autoClose || 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    setTimeout(() => {

        toast.update(id, {
            type: toast.TYPE.INFO,
            render: message2 || "NO message",
            autoClose: autoCloseUpdate
        })
    }, 2000);

};

export const errorSwalNotification = (message, title = '', icon) => {
    Swal.fire({
        target: document.getElementById('dialog') || document.getElementById('dialogX'),
        title: '<small>' + title + '</small>',
        html: '<small>  <p align="center">' + message + '</p> </small>',
        icon: icon || 'error',
        allowOutsideClick: false,
        showConfirmButton: true,
        allowEscapeKey: false,       
    });
};

export const succesSwalNotification = (objeto, title = '') => {
    const { estado, contribuyente, tipoDocumento, direccionEstablecimiento, fechaCaducidad } = objeto;

    Swal.fire({
        target: document.getElementById('dialog'),
        title: '<small>' + title + '</small>',
        html: `
        <div style="text-align: left;">
            <p><b><small>${estado}</small></b></p>
            <p><small><b>Tipo Documento:</b> ${tipoDocumento}</small></p>
            <p><small><b>Dirección Establecimiento:</b> ${direccionEstablecimiento}</small></p>
            <p><small><b>Fecha Caducidad:</b> ${fechaCaducidad}</small></p> 
            <h4><small>Datos del Contribuyente:</small></h4>
            <p><small><b>Identificación:</b> ${contribuyente.identificacion}</small></p>
            <p><small><b>Razón Social:</b> ${contribuyente.denominacion}</small></p>
            <p><small><b>Tipo:</b> ${contribuyente.tipo}</small></p>
            <p><small><b>Dirección Matriz:</b> ${contribuyente.direccionMatriz}</small></p>
        </div>
    `,
        icon: 'success',
        allowOutsideClick: false,
        showConfirmButton: true,
        allowEscapeKey: false
    });
};
export const showConfirmationDialog = (message, title = '', onConfirm) => {
    Swal.fire({
        title: title,
        html: message,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#6fbf73',
        cancelButtonColor: '#d33',
        confirmButtonText: '<small>Si</small>',
        cancelButtonText: '<small>Cancelar!</small>',
        target: document.getElementById('dialog') || undefined, // Target if 'dialog' element exists
    }).then((result) => {
        if (result.isConfirmed) {
            onConfirm();
        }
    });
};
const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const MessageError = (props) => {
    return (
        <Fragment>
            <Snackbar
                open={props.open}
                autoHideDuration={5000}
                onClose={props.onClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={props.onClose} severity="error" sx={{ width: '50%' }}>
                    {props.message}
                </Alert>
            </Snackbar>
        </Fragment>
    );
};

export default MessageError;

// export const saveNotification = (message, messageTitle) => {

//   toast.success(<div
//     style={{
//       height: "100%",
//       borderLeft: "5px solid green",
//       display: "flex",
//       alignItems: "center",
//       paddingLeft: 5
//     }}
//   >
//     <CheckCircleOutlineIcon color={"green"} height="25px" width="25px" />
//     <span style={{ fontWeight: "bold", color: "#000" }}>{message}</span>
//     {"  "}<br></br>
//     <span style={{ marginLeft: 5 }}>{messageTitle}</span>
//   </div>,

//   {
//       position: "top-right",
//       autoClose: 3000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//       newestOnTop:false,
//       rtl:false,

//     });
// };
